import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { from, Observable, of } from 'rxjs';
import { RootState } from 'app/core/store/index';
import { AzureMonitoringService } from 'app/core/services/AzureMonitoringService';
import { CustomersRestService } from 'app/core/services/rest/customers.rest.service';
import { StockRestService } from 'app/core/services/rest/stock.rest.service';
import { AbstractEffects } from 'app/core/store/AbstractEffects';
import * as actions from 'app/core/store/contract-details/customer-summary/customer-summary.actions';
import { CustomerSummaryMW } from 'app/core/store/contract-details/customer-summary/customer-summary.interface';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { NotificationService } from 'app/core/services/notification.service';
import { AuthenticationService } from '../../../authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class CustomerSummaryEffects extends AbstractEffects {

  private authenticationService = inject(AuthenticationService);

  loadCustomerSummary$: Observable<{}> = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.CUSTOMER_SUMMARY_LOAD),
      withLatestFrom(this.authenticationService.authenticated$, (action, isAuthenticated) => ({
        action,
        isAuthenticated,
      })),
      filter(({ isAuthenticated }: { isAuthenticated: boolean }) => isAuthenticated),
      withLatestFrom(this.store, (action, state) => {
        return { state };
      }),
      switchMap(({ state }) => {
        return from(this.customersRestService.getCustomerSummary(state.session.selectedCustomer.loadSuccess && state.session.selectedCustomer.data?.id)).pipe(
          map((customerSummary: CustomerSummaryMW) => {
            return new actions.CustomerSummarySuccessAction({ customerSummary });
          }),
          catchError(err => this.handleFail(err, 'Get customer summary', [of(new actions.CustomerSummaryFailAction(err))]))
        );
      })
    )
  );

  constructor(
    private store: Store<RootState>,
    azureMonitoringService: AzureMonitoringService,
    private actions$: Actions,
    private customersRestService: CustomersRestService,
    private stockRestService: StockRestService,
    translateService: TranslateService,
    notificationService: NotificationService
  ) {
    super(translateService, azureMonitoringService, notificationService);
  }
}
